import { makeStyles } from 'lib/components';

export default makeStyles(() => ({
  paper: {
    display: 'flex',
    margin: '0px',
    padding: '24px',
    gap: '24px',
    flex: 1,
    flexDirection: 'column',
    '@media (min-width: 640px)': {
      flexDirection: 'row',
      margin: '20px',
    },
  },

  container: {
    flex: 1,
    alignItems: 'center',
    marginTop: '84px',
    gap: '20px',
    '@media (max-width: 640px)': {
      marginTop: '0px',
      justifyContent: 'center',
    },
  },

  title: {
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    textAlign: 'center',
    padding: '5px',
    color: '#000000',
  },

  button: {
    '@media (max-width: 640px)': {
      flexBasis: 0,
      width: '100%',
    },
  },
}));
